import React from "react";
import Layout from "../components/layout";
import DarkHero from "../components/darkHero";
import SEO from "../components/seo";
import SliceR from "../components/slice-r";

const IndustryPage = ({ pageContext }) => {

  const industry = pageContext.node.data;
  const body = pageContext.node.data.body;

  return (
    <Layout>
      <SEO
        title={industry.meta_title}
        image={industry.meta_og_image.url}
        noindex={industry.meta_noindex}
        description={industry.meta_description}
        canonical={
          typeof window !== "undefined" &&
          window.location.origin + window.location.pathname
        }
      />
      <DarkHero
        title={industry?.hero_title}
        taglineImage={industry?.tagline_image}
        taglineImageSize={industry?.tagline_image_size}
        summary={industry?.hero_summary}
        summaryImage={industry?.summary_background_image}
        cardHeader={industry?.card_section_heading}
        cardSection={industry?.card_section}
        cardSectionBorder={industry?.card_section_border}
        cardDivider={industry?.section_divider}
        cardBenefitsDescription={industry?.benefits_description}
        cardBenefitsHeader={industry?.benefits_header}
        cardBenefitsPodBorder={industry?.benefits_pod_border}
        cardBenefitsPods={industry?.benefits_pods}
        cardFooterIcon={industry?.card_footer_icon}
        cardFooterDescription={industry?.card_footer_description}
        anchorOrLink={industry?.anchor_or_link}
        anchorId={industry?.anchor_id}
        cardFooterCtaText={industry?.card_footer_cta_text}
        cardFooterCtaLink={industry?.card_footer_cta_link}
        buttonBorder={industry?.button_border}
      />
      <section className="pageContainer">
        <div className="exampleWrapper">
          <img src={industry?.tagline_image?.url} alt={industry?.tagline_image?.alt} />
          <div className="smallDarkHeaderBlock">
            {industry?.example_header}
          </div>
          <h3 className="exampleDescription">
            {industry?.example_description}
          </h3>
        </div>
        {body.map((slice, index) => {
          const isAltBackground = index % 2 === 1;
          return <SliceR key={index} data={slice} isAltBackground={isAltBackground} />
        })}
      </section>
    </Layout>
  )
}

export default IndustryPage;